import DetailBDSGeneralInformation from "./DetailBDSGeneralInformation";
import { Accordion } from 'components/common';
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';
import { VALUE_CLS, CHECK_DISPLAY_CLS, TH_CLS, TD_CLS, SECTION_BODY_CLS } from "../pifStyles";
import { useDiffMark, useRowMark, useDiffTitle } from "./PifDiffContext";
import DiffRichText from "./DiffRichText";

const DetailBDS2 = ({project, building, adaptation, area, areaIndex}) => {
  const {bds2} = area
  const roofExtensionData = bds2?.roof_extensions || []
  const canopyData = bds2?.canopies || []
  const fasciaData = bds2?.fascias || []
  const frameOpeningData = bds2?.frame_openings || []
  const mezzanineData = bds2?.mezzanines || []
  const craneInformationData = bds2?.crane_informations || []
  const mark = useDiffMark();
  const rowMark = useRowMark();
  const p = (k) => `areas[${areaIndex}].bds2.${k}`;
  const rmark = (arr, item, index) => rowMark(`areas[${areaIndex}].bds2.${arr}[${item?.id}]`, `areas[${areaIndex}].bds2.${arr}[${index}]`);
  const vcls = (k) => `${VALUE_CLS}${mark(p(k))}`;
  // old → new tooltip for a highlighted field (inert when not changed).
  const title = useDiffTitle();
  const vtitle = (k) => title(p(k));

  const {bds2: initialKeys} = useSelector(state => state.crm_project_pif.initialKeys)
  const [activeKey, setActiveKey] = useState(initialKeys)

  useEffect(() => {
    setActiveKey(initialKeys);
  }, [initialKeys]);

  const handleAccordionSelect = (newActiveKey) => {
    setActiveKey(newActiveKey)
  }

  return (
    <Accordion
      activeKeys={activeKey}
      onChange={handleAccordionSelect}
      className="tw-text-sm"
    >
      <Accordion.Item eventKey="0" header="General Information">
        <div className={SECTION_BODY_CLS}>
          <DetailBDSGeneralInformation
            project={project}
            building={building}
            adaptation={adaptation}
            area={area}
          />
          <h6 className="tw-text-center tw-my-2">This area only : Page 2 of 3</h6>
        </div>
      </Accordion.Item>

      {/* 12. Roof Extension */}
      <Accordion.Item eventKey="1" header="12. Roof Extension">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-overflow-x-auto tw-text-sm tw-mt-2">
            <table className="tw-w-full tw-border-collapse tw-text-sm">
              <thead>
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <th className={TH_CLS} rowSpan={2}>Location</th>
                  <th className={TH_CLS} rowSpan={2}>Qty</th>
                  <th className={TH_CLS} rowSpan={2}>Width (M)</th>
                  <th className={TH_CLS} rowSpan={2}>Length (M)</th>
                  <th className={TH_CLS} colSpan={2}>Soffit panel</th>
                  <th className={TH_CLS} rowSpan={2}>Insulated</th>
                  <th className={TH_CLS} rowSpan={2}>Description</th>
                </tr>
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <td className={TH_CLS}>By</td>
                  <td className={TH_CLS}>Description</td>
                </tr>
              </thead>
              <tbody>
                {roofExtensionData && roofExtensionData.map((item, index) => (
                  <tr key={index} className={rmark('roof_extensions', item, index)}>
                    <td className={TD_CLS}>{item.location}</td>
                    <td className={TD_CLS}>{item.qty}</td>
                    <td className={TD_CLS}>{item.width}</td>
                    <td className={TD_CLS}>{item.length}</td>
                    <td className={TD_CLS}>{item.soffit_panel_by}</td>
                    <td className={TD_CLS}>{item.soffit_panel_description}</td>
                    <td className={TD_CLS}>{item.insulated}</td>
                    <td className={TD_CLS}>{item.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-mt-3">
            <DiffRichText path={p('roof_extension_note')} html={bds2.roof_extension_note} />
          </div>
        </div>
      </Accordion.Item>

      {/* 13. Canopy */}
      <Accordion.Item eventKey="2" header="13. Canopy">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-overflow-x-auto tw-text-sm tw-mt-2">
            <table className="tw-w-full tw-border-collapse tw-text-sm">
              <thead>
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <th className={TH_CLS} rowSpan={2}>Location</th>
                  <th className={TH_CLS} rowSpan={2}>Qty</th>
                  <th className={TH_CLS} rowSpan={2}>Width (M)</th>
                  <th className={TH_CLS} rowSpan={2}>Length (M)</th>
                  <th className={TH_CLS} rowSpan={2}>Clear height (M)</th>
                  <th className={TH_CLS} rowSpan={2}>Eave condition</th>
                  <th className={TH_CLS} rowSpan={2}>Slope</th>
                  <th className={TH_CLS} colSpan={3}>Roof panel</th>
                  <th className={TH_CLS} colSpan={3}>Endwall panel</th>
                  <th className={TH_CLS} colSpan={3}>Soffit panel</th>
                </tr>
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <td className={TH_CLS}>By</td>
                  <td className={TH_CLS}>Description</td>
                  <td className={TH_CLS}>Color</td>

                  <td className={TH_CLS}>By</td>
                  <td className={TH_CLS}>Description</td>
                  <td className={TH_CLS}>Color</td>

                  <td className={TH_CLS}>By</td>
                  <td className={TH_CLS}>Description</td>
                  <td className={TH_CLS}>Color</td>
                </tr>
              </thead>
              <tbody>
                {canopyData && canopyData.map((item, index) => (
                  <tr key={index} className={rmark('canopies', item, index)}>
                    <td className={TD_CLS}>{item.location}</td>
                    <td className={TD_CLS}>{item.qty}</td>
                    <td className={TD_CLS}>{item.width}</td>
                    <td className={TD_CLS}>{item.length}</td>
                    <td className={TD_CLS}>{item.clear_height}</td>
                    <td className={TD_CLS}>{item.eave_condition}</td>
                    <td className={TD_CLS}>{item.slope}</td>

                    <td className={TD_CLS}>{item.roof_panel_by}</td>
                    <td className={TD_CLS}>{item.roof_panel_description}</td>
                    <td className={TD_CLS}>{item.roof_panel_color}</td>

                    <td className={TD_CLS}>{item.end_wall_panel_by}</td>
                    <td className={TD_CLS}>{item.end_wall_panel_description}</td>
                    <td className={TD_CLS}>{item.end_wall_panel_color}</td>

                    <td className={TD_CLS}>{item.soffit_panel_by}</td>
                    <td className={TD_CLS}>{item.soffit_panel_description}</td>
                    <td className={TD_CLS}>{item.soffit_panel_color}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-mt-3">
            <DiffRichText path={p('capony_note')} html={bds2.capony_note} />
          </div>
        </div>
      </Accordion.Item>

      {/* 14. Fascia */}
      <Accordion.Item eventKey="3" header="14. Fascia">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-overflow-x-auto tw-text-sm tw-mt-2">
            <table className="tw-w-full tw-border-collapse tw-text-sm">
              <thead>
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <th className={TH_CLS} rowSpan={2}>Location</th>
                  <th className={TH_CLS} rowSpan={2}>Qty</th>
                  <th className={TH_CLS} rowSpan={2}>Type</th>
                  <th className={TH_CLS} rowSpan={2}>Height (M)</th>
                  <th className={TH_CLS} rowSpan={2}>Length (M)</th>
                  <th className={TH_CLS} rowSpan={2}>Proj. (M)</th>

                  <th className={TH_CLS} colSpan={3}>Fascia panel</th>
                  <th className={TH_CLS} colSpan={3}>Soffit panel</th>
                  <th className={TH_CLS} colSpan={3}>Backup panel</th>
                </tr>
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <td className={TH_CLS}>By</td>
                  <td className={TH_CLS}>Description</td>
                  <td className={TH_CLS}>Color</td>

                  <td className={TH_CLS}>By</td>
                  <td className={TH_CLS}>Description</td>
                  <td className={TH_CLS}>Color</td>

                  <td className={TH_CLS}>By</td>
                  <td className={TH_CLS}>Description</td>
                  <td className={TH_CLS}>Color</td>
                </tr>
              </thead>
              <tbody>
                {fasciaData && fasciaData.map((item, index) => (
                  <tr key={index} className={rmark('fascias', item, index)}>
                    <td className={TD_CLS}>{item.location}</td>
                    <td className={TD_CLS}>{item.qty}</td>
                    <td className={TD_CLS}>{item.fascia_type}</td>
                    <td className={TD_CLS}>{item.height}</td>
                    <td className={TD_CLS}>{item.length}</td>
                    <td className={TD_CLS}>{item.proj}</td>

                    <td className={TD_CLS}>{item.fasica_panel_by}</td>
                    <td className={TD_CLS}>{item.fasica_panel_description}</td>
                    <td className={TD_CLS}>{item.fasica_panel_color}</td>

                    <td className={TD_CLS}>{item.soffit_panel_by}</td>
                    <td className={TD_CLS}>{item.soffit_panel_description}</td>
                    <td className={TD_CLS}>{item.soffit_panel_color}</td>

                    <td className={TD_CLS}>{item.backup_panel_by}</td>
                    <td className={TD_CLS}>{item.backup_panel_description}</td>
                    <td className={TD_CLS}>{item.backup_panel_color}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-mt-3">
            <DiffRichText path={p('fascia_note')} html={bds2.fascia_note} />
          </div>
        </div>
      </Accordion.Item>

      {/* 15. Frame Opening */}
      <Accordion.Item eventKey="4" header="15. Frame Opening">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-overflow-x-auto tw-text-sm tw-mt-2">
            <table className="tw-w-full tw-border-collapse tw-text-sm">
              <thead>
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <th className={TH_CLS} rowSpan={2}>Qty</th>
                  <th className={TH_CLS} rowSpan={2}>Width (mm)</th>
                  <th className={TH_CLS} rowSpan={2}>Height (mm)</th>
                  <th className={TH_CLS} rowSpan={2}>For</th>
                  <th className={TH_CLS} rowSpan={2}>Doors, window,…By</th>
                  <th className={TH_CLS} rowSpan={2}>Location</th>
                </tr>
              </thead>
              <tbody>
                {frameOpeningData && frameOpeningData.map((item, index) => (
                  <tr key={index} className={rmark('frame_openings', item, index)}>
                    <td className={TD_CLS}>{item.qty}</td>
                    <td className={TD_CLS}>{item.width}</td>
                    <td className={TD_CLS}>{item.height}</td>
                    <td className={TD_CLS}>{item.frame_opening_for}</td>
                    <td className={TD_CLS}>{item.door_window_by}</td>
                    <td className={TD_CLS}>{item.location}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-mt-3">
            <DiffRichText path={p('frame_opening_note')} html={bds2.frame_opening_note} />
          </div>
        </div>
      </Accordion.Item>

      {/* 16. Mezzanine */}
      <Accordion.Item eventKey="5" header="16. Mezzanine">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2">
            <div className="tw-col-span-7">
              <div className="tw-flex tw-gap-x-2">
                <div>PEB to Supply :</div>
                <div className="tw-flex-1">
                  <div className="tw-flex tw-justify-between">
                    <label className="tw-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        className={CHECK_DISPLAY_CLS}
                        checked={!!bds2.mezzinine_peb_supply_cols}
                        readOnly
                      />
                      <span className={mark(p('mezzinine_peb_supply_cols'))} title={vtitle('mezzinine_peb_supply_cols')}>Cols</span>
                    </label>

                    <label className="tw-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        className={CHECK_DISPLAY_CLS}
                        checked={!!bds2.mezzinine_peb_supply_beams}
                        readOnly
                      />
                      <span className={mark(p('mezzinine_peb_supply_beams'))} title={vtitle('mezzinine_peb_supply_beams')}>Beams</span>
                    </label>

                    <label className="tw-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        className={CHECK_DISPLAY_CLS}
                        checked={!!bds2.mezzinine_peb_supply_joists}
                        readOnly
                      />
                      <span className={mark(p('mezzinine_peb_supply_joists'))} title={vtitle('mezzinine_peb_supply_joists')}>Joists</span>
                    </label>

                    <label className="tw-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        className={CHECK_DISPLAY_CLS}
                        checked={!!bds2.mezzinine_peb_supply_deck}
                        readOnly
                      />
                      <span className={mark(p('mezzinine_peb_supply_deck'))} title={vtitle('mezzinine_peb_supply_deck')}>Deck</span>
                    </label>

                    <label className="tw-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        className={CHECK_DISPLAY_CLS}
                        checked={!!bds2.mezzinine_peb_supply_handrails_mezz}
                        readOnly
                      />
                      <span className={mark(p('mezzinine_peb_supply_handrails_mezz'))} title={vtitle('mezzinine_peb_supply_handrails_mezz')}>Handrails Mezz.</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-x-2">
                <div>
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      className={CHECK_DISPLAY_CLS}
                      checked={!!bds2.mezzinine_apply_load_only}
                      readOnly
                    />
                    <span className={mark(p('mezzinine_apply_load_only'))} title={vtitle('mezzinine_apply_load_only')}>Apply loads only</span>
                  </label>
                </div>
                <div className="tw-flex-1">
                  <span className={vcls('mezzinine_apply_load_only_specify')} title={vtitle('mezzinine_apply_load_only_specify')}>{bds2.mezzinine_apply_load_only_specify}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-overflow-x-auto tw-text-sm tw-mt-2">
            <table className="tw-w-full tw-border-collapse tw-text-sm">
              <thead>
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <th className={TH_CLS} rowSpan={2}>Mz no</th>
                  <th className={TH_CLS} rowSpan={2}>DL (kN/m2)</th>
                  <th className={TH_CLS} rowSpan={2}>LL (kN/m2)</th>
                  <th className={TH_CLS} rowSpan={2}>Coll (kN/m2)</th>
                  <th className={TH_CLS} rowSpan={2}>Area (m2)</th>
                  <th className={TH_CLS} rowSpan={2}>Clearance (mm)</th>
                  <th className={TH_CLS} colSpan={2}>Floor</th>
                  <th className={TH_CLS} rowSpan={2}>Stair Type</th>
                  <th className={TH_CLS} rowSpan={2}>Qty</th>
                  <th className={TH_CLS} rowSpan={2}>Width (mm) (IN/IN ofStringer)</th>
                  <th className={TH_CLS} colSpan={2}>Landing</th>
                  <th className={TH_CLS} rowSpan={2}>Tread Type</th>
                  <th className={TH_CLS} rowSpan={2}>Hand Rail</th>
                </tr>
                <tr className="tw-text-center">
                  <th className={TH_CLS}>Type</th>
                  <th className={TH_CLS}>Total thickness (mm)</th>

                  <th className={TH_CLS}>Mid</th>
                  <th className={TH_CLS}>Top</th>
                </tr>
              </thead>
              <tbody>
                {mezzanineData && mezzanineData.map((item, index) => (
                  <tr key={index} className={rmark('mezzanines', item, index)}>
                    <td className={TD_CLS}>{item.mz_no}</td>
                    <td className={TD_CLS}>{item.dl}</td>
                    <td className={TD_CLS}>{item.ll}</td>
                    <td className={TD_CLS}>{item.coll}</td>
                    <td className={TD_CLS}>{item.area}</td>
                    <td className={TD_CLS}>{item.clearance}</td>
                    <td className={TD_CLS}>{item.floor_type}</td>
                    <td className={TD_CLS}>{item.floor_t}</td>
                    <td className={TD_CLS}>{item.stair_type}</td>
                    <td className={TD_CLS}>{item.qty}</td>
                    <td className={TD_CLS}>{item.width}</td>
                    <td className={`${TD_CLS} tw-text-center`}>
                      <input
                        type="checkbox"
                        className={CHECK_DISPLAY_CLS}
                        name={`landing_mid_${item.id}`}
                        checked={!!item.landing_mid}
                        readOnly
                      />
                    </td>
                    <td className={`${TD_CLS} tw-text-center`}>
                      <input
                        type="checkbox"
                        className={CHECK_DISPLAY_CLS}
                        name={`landing_top_${item.id}`}
                        checked={!!item.landing_top}
                        readOnly
                      />
                    </td>
                    <td className={TD_CLS}>{item.tread_type}</td>
                    <td className={TD_CLS}>{item.hand_rail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-mt-3 tw-mb-2">
            <DiffRichText path={p('mezzanine_note')} html={bds2.mezzanine_note} />
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  className={CHECK_DISPLAY_CLS}
                  checked={!!bds2.mezzinine_concrete_floor_thickness}
                  readOnly
                />
                <span className={mark(p('mezzinine_concrete_floor_thickness'))} title={vtitle('mezzinine_concrete_floor_thickness')}>Is Concrete floor thickness included finished floor?</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Finish floor thickness (mm):</div>
                <div className="tw-flex-1">
                  <span className={vcls('mezzinine_finish_floor_thickness')} title={vtitle('mezzinine_finish_floor_thickness')}>{bds2.mezzinine_finish_floor_thickness}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-2 tw-items-center">
            <div>Edge of mezzanine slab is expanded to out of :</div>
            <div className="tw-flex-1">
              <span className={vcls('mezzanine_edge_slab')} title={vtitle('mezzanine_edge_slab')}>{bds2.mezzanine_edge_slab}</span>
            </div>
          </div>
        </div>
      </Accordion.Item>

      {/* 17. Roof Monitor */}
      <Accordion.Item eventKey="6" header="17. Roof Monitor">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Width at throat (mm):</div>
                <div className="tw-flex-1">
                  <span className={vcls('roof_monitor_width')} title={vtitle('roof_monitor_width')}>{bds2.roof_monitor_width}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Height (mm):</div>
                <div className="tw-flex-1">
                  <span className={vcls('roof_monitor_height')} title={vtitle('roof_monitor_height')}>{bds2.roof_monitor_height}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Roof Slope:</div>
                <div className="tw-flex-1">
                  <span className={vcls('roof_monitor_slope')} title={vtitle('roof_monitor_slope')}>{bds2.roof_monitor_slope}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2">
            <div className="tw-col-span-4">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Eave Condition:</div>
                <div className="tw-flex-1">
                  <span className={vcls('roof_monitor_eave_condition')} title={vtitle('roof_monitor_eave_condition')}>{bds2.roof_monitor_eave_condition}</span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-8">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Roof panel &amp; color:</div>
                <div className="tw-flex-1">
                  <span className={vcls('roof_monitor_panel_and_color')} title={vtitle('roof_monitor_panel_and_color')}>{bds2.roof_monitor_panel_and_color}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-3 tw-items-center">
            <div>Wall Condition:</div>
            <div className="tw-flex-1">
              <span className={vcls('roof_monitor_wall_condition')} title={vtitle('roof_monitor_wall_condition')}>{bds2.roof_monitor_wall_condition}</span>
            </div>
          </div>
          <div>
            <DiffRichText path={p('roof_monitor_note')} html={bds2.roof_monitor_note} />
          </div>
        </div>
      </Accordion.Item>

      {/* 18. Ridge Vent */}
      <Accordion.Item eventKey="7" header="18. Ridge Vent">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div>
              <div className="tw-flex tw-gap-x-2">
                <div>RV Type:</div>
                <div className="tw-flex-1">
                  <span className={vcls('ridge_vent_rv_type')} title={vtitle('ridge_vent_rv_type')}>{bds2.ridge_vent_rv_type}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1 tw-items-center tw-mt-2 tw-ml-3">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  className={CHECK_DISPLAY_CLS}
                  checked={!!bds2.ridge_vent_non_standard}
                  readOnly
                />
                <span className={mark(p('ridge_vent_non_standard'))} title={vtitle('ridge_vent_non_standard')}>NON-STANDARD</span>
              </label>
            </div>
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-3">
            <div>
              <div className="tw-mb-1">Quantity:</div>
              <span className={vcls('ridge_vent_qty')} title={vtitle('ridge_vent_qty')}>{bds2.ridge_vent_qty}</span>
            </div>
            <div className="tw-flex-1">
              <div className="tw-mb-1">Length:</div>
              <span className={vcls('ridge_vent_length')} title={vtitle('ridge_vent_length')}>{bds2.ridge_vent_length}</span>
            </div>
            <div className="tw-flex-1">
              <div className="tw-mb-1">Roof panel:</div>
              <span className={vcls('ridge_vent_roof_panel')} title={vtitle('ridge_vent_roof_panel')}>{bds2.ridge_vent_roof_panel}</span>
            </div>
            <div className="tw-flex-1">
              <div className="tw-mb-1">Color:</div>
              <span className={vcls('ridge_vent_color')} title={vtitle('ridge_vent_color')}>{bds2.ridge_vent_color}</span>
            </div>
            <div className="tw-flex-1">
              <div className="tw-mb-1">Remark:</div>
              <span className={vcls('ridge_vent_remark')} title={vtitle('ridge_vent_remark')}>{bds2.ridge_vent_remark}</span>
            </div>
          </div>
          <div>
            <DiffRichText path={p('ridge_vent_note')} html={bds2.ridge_vent_note} />
          </div>
        </div>
      </Accordion.Item>

      {/* 19. Crane Information */}
      <Accordion.Item eventKey="8" header="19. Crane Information">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div>Scope of Supply:</div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-justify-between">
                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    className={CHECK_DISPLAY_CLS}
                    checked={!!bds2.crane_only_apply_loads}
                    readOnly
                  />
                  <span className={mark(p('crane_only_apply_loads'))} title={vtitle('crane_only_apply_loads')}>Only Apply Loads,</span>
                </label>

                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    className={CHECK_DISPLAY_CLS}
                    checked={!!bds2.crane_beams_brackets}
                    readOnly
                  />
                  <span className={mark(p('crane_beams_brackets'))} title={vtitle('crane_beams_brackets')}>Crane Beams &amp; Brackets,</span>
                </label>

                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    className={CHECK_DISPLAY_CLS}
                    checked={!!bds2.crane_rails}
                    readOnly
                  />
                  <span className={mark(p('crane_rails'))} title={vtitle('crane_rails')}>Rails,</span>
                </label>

                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    className={CHECK_DISPLAY_CLS}
                    checked={!!bds2.crane_system}
                    readOnly
                  />
                  <span className={mark(p('crane_system'))} title={vtitle('crane_system')}>Crane system,</span>
                </label>

                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    className={CHECK_DISPLAY_CLS}
                    checked={!!bds2.crane_bracket_only}
                    readOnly
                  />
                  <span className={mark(p('crane_bracket_only'))} title={vtitle('crane_bracket_only')}>Bracket only,</span>
                </label>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div>
              <div className="tw-flex tw-gap-x-2 tw-mb-3 tw-items-center">
                <div>Power Supply. Volts:</div>
                <div className="tw-flex-1">
                  <span className={vcls('crane_power_supply_volt')} title={vtitle('crane_power_supply_volt')}>{bds2.crane_power_supply_volt}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-x-2 tw-mb-3 tw-items-center">
                <div>Hz:</div>
                <div className="tw-flex-1">
                  <span className={vcls('crane_hz')} title={vtitle('crane_hz')}>{bds2.crane_hz}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-x-2 tw-mb-3 tw-items-center">
                <div>Phases:</div>
                <div className="tw-flex-1">
                  <span className={vcls('crane_phase')} title={vtitle('crane_phase')}>{bds2.crane_phase}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-x-2 tw-mb-3 tw-items-center">
                <div>Manufacturer:</div>
                <div className="tw-flex-1">
                  <span className={vcls('crane_manufacturer')} title={vtitle('crane_manufacturer')}>{bds2.crane_manufacturer}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-overflow-x-auto tw-text-sm tw-mt-2">
            <table className="tw-w-full tw-border-collapse tw-text-sm">
              <thead>
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <th className={TH_CLS} rowSpan={2}>No.</th>
                  <th className={TH_CLS} rowSpan={2}>Crane Type</th>
                  <th className={TH_CLS} colSpan={3}>Span</th>
                  <th className={TH_CLS} colSpan={3}>Run length</th>
                  <th className={TH_CLS} rowSpan={2}>Capacity (M.T)</th>
                  <th className={TH_CLS} rowSpan={2}>Wheel Load (kN)</th>
                  <th className={TH_CLS} rowSpan={2}>Wheel Base (mm)</th>
                  <th className={TH_CLS} rowSpan={2}>Bumper (mm)</th>
                  <th className={TH_CLS} rowSpan={2}>Min. Hook Height</th>
                  <th className={TH_CLS} rowSpan={2}>Top of Crane Beam</th>
                  <th className={TH_CLS} rowSpan={2}>Bridge Weight (kg)</th>
                  <th className={TH_CLS} rowSpan={2}>Trolley Weight (kg)</th>
                  <th className={TH_CLS} colSpan={2}>Operaion</th>
                </tr>
                <tr className="tw-text-center">
                  <th className={TH_CLS}>W1 (m)</th>
                  <th className={TH_CLS}>From (GL)</th>
                  <th className={TH_CLS}>To (GL)</th>

                  <th className={TH_CLS}>(m)</th>
                  <th className={TH_CLS}>From (GL)</th>
                  <th className={TH_CLS}>To (GL)</th>

                  <th className={TH_CLS}>Pendant</th>
                  <th className={TH_CLS}>Cab</th>
                </tr>
              </thead>
              <tbody>
                {craneInformationData && craneInformationData.map((item, index) => (
                  <tr key={index} className={rmark('crane_informations', item, index)}>
                    <td className={TD_CLS}>{item.crane_sr}</td>
                    <td className={TD_CLS}>{item.crane_type}</td>
                    <td className={TD_CLS}>{item.span_w1}</td>
                    <td className={TD_CLS}>{item.span_from_gl}</td>
                    <td className={TD_CLS}>{item.span_to_gl}</td>
                    <td className={TD_CLS}>{item.run_length}</td>
                    <td className={TD_CLS}>{item.run_length_from_gl}</td>
                    <td className={TD_CLS}>{item.run_length_to_gl}</td>
                    <td className={TD_CLS}>{item.capacity}</td>
                    <td className={TD_CLS}>{item.wheel_load}</td>
                    <td className={TD_CLS}>{item.wheel_base}</td>
                    <td className={TD_CLS}>{item.bumper}</td>
                    <td className={TD_CLS}>{item.min_hook_height}</td>
                    <td className={TD_CLS}>{item.top_of_crane_beam}</td>
                    <td className={TD_CLS}>{item.bridge_weight}</td>
                    <td className={TD_CLS}>{item.trolley_weight}</td>

                    <td className={`${TD_CLS} tw-text-center`}>
                      <input
                        type="checkbox"
                        className={CHECK_DISPLAY_CLS}
                        checked={!!item.operation_pendant}
                        readOnly
                      />
                    </td>
                    <td className={`${TD_CLS} tw-text-center`}>
                      <input
                        type="checkbox"
                        className={CHECK_DISPLAY_CLS}
                        checked={!!item.operation_cab}
                        readOnly
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-mt-3 tw-mb-2">
            <DiffRichText path={p('crane_information_note')} html={bds2.crane_information_note} />
          </div>
        </div>
      </Accordion.Item>

      <Accordion.Item eventKey="9" header="Attached">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-flex tw-justify-between">
            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds2.attached_for_this_building}
                readOnly
              />
              <span className={mark(p('attached_for_this_building'))} title={vtitle('attached_for_this_building')}>For This Building/ Area Only,</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds2.attached_bldg_data_sheet3}
                readOnly
              />
              <span className={mark(p('attached_bldg_data_sheet3'))} title={vtitle('attached_bldg_data_sheet3')}>BLDG.Data Sheet 3,</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds2.attached_bldg_data_sheet4}
                readOnly
              />
              <span className={mark(p('attached_bldg_data_sheet4'))} title={vtitle('attached_bldg_data_sheet4')}>BLDG.Data Sheet 4,</span>
            </label>
          </div>
        </div>
      </Accordion.Item>
    </Accordion>
  )
};

DetailBDS2.propTypes = {
  project: PropTypes.object.isRequired,
  building: PropTypes.object.isRequired,
  adaptation: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  areaIndex: PropTypes.number
}

export default DetailBDS2;
